import { Alert } from 'reactstrap';
import { Link } from 'react-router-dom';
import { BiTime } from 'react-icons/bi';
import useBillingStatus from '../../hooks/useBillingStatus';

// Whole-number days left until `trialEndsAt`, floored at 0. Uses ceil so the
// last partial day still reads as "1 day left" rather than "0".
function daysLeft(trialEndsAt) {
    const ms = new Date(trialEndsAt).getTime() - Date.now();
    return Math.max(0, Math.ceil(ms / (1000 * 60 * 60 * 24)));
}

// App-wide trial countdown. Renders only while the company is on the no-card
// trial (status === 'trialing' with a trialEndsAt from Billing/Status). Turns
// warning-coloured in the final stretch so the nudge to subscribe sharpens as
// the trial runs out. Paid/expired accounts render nothing.
export default function TrialBanner() {
    const { data } = useBillingStatus();

    if (!data || data.status !== 'trialing' || !data.trialEndsAt) return null;

    const left = daysLeft(data.trialEndsAt);
    const urgent = left <= 3;
    const dayLabel = left === 1 ? 'day' : 'days';

    return (
        <Alert
            color={urgent ? 'warning' : 'info'}
            className="d-flex flex-wrap align-items-center gap-2 mb-0 rounded-0 border-0"
        >
            <BiTime />
            <span>
                {left === 0
                    ? 'Your free trial ends today.'
                    : <>You have <strong>{left} {dayLabel}</strong> left on your free trial.</>}
            </span>
            <Link to="/subscribe" className="fw-semibold ms-auto">
                Choose a plan →
            </Link>
        </Alert>
    );
}
